<m-title><naming-convention-label [type]="'EndUser'" [singular]="false"></naming-convention-label></m-title>

<div class="mip-btn-container">
    <p-button
        label="Filters"
        icon="pi pi-filter-fill"
        (onClick)="toggleFilter()"
        styleClass="p-button-secondary mip-marbtn-r"></p-button>
    <button pButton class="p-button-secondary" label="Merge {{namingConvService.endUserPlural}}" routerLink="./merge"></button>
    <button pButton allowOffline class="m-button-primary ml-2" label="Add {{namingConvService.endUserPlural}}" (click)="onAddPatientClick()"></button>
</div>

<div class="card card-pad-mod" [hidden]="!filterVisible">
    <filter class="groups-filter" #playersFilter [settings]="filterSettings"  >
        <ng-template filterCustomTemplate="groups" let-filterItem>
            <p-multiSelect
                [group]="multipleOrganizationFilter"
                [(ngModel)]="filterItem.value"
                [placeholder]="namingConvService.groupPlural"
                [options]="groupOptions"
                appendTo="body"
                display="chip"
                [disabled] = "!this.isOnline"
                (ngModelChange)="autoSearchOn()"
                >
            </p-multiSelect>
        </ng-template>

        <ng-template filterCustomTemplate="showArchived" let-filterItem>
            <p-checkbox [(ngModel)]="filterItem.value" label="Show Archived" class="private-box" name="group" binary="true"></p-checkbox>
        </ng-template>
    </filter>
</div>

<div class="card main-container">
    <grid *miproLoading="initializingGrid" #grid [tableSettings]="tableSettings" [gridSettings]="gridSettings" [filter]="playersFilter"></grid>
</div>

<create-player-dialog [data]="offlinePatient" [(visible)]="editingPatient" (playerCreated)="patientCreated($event)"></create-player-dialog>

<form-event-workflow
    [formEventType] = "FormEventType.CreatePatient" >
</form-event-workflow>  

<p-dialog [(visible)]="selectEditInfoVisible" header="Select Patient email">
    <grid #editInfoGrid [gridSettings]="editInfoGridSettings" [tableSettings]="editInfoTableSettings"></grid>
    <ng-template pTemplate="footer">
        <button pButton label="Cancel" (click)="selectEditInfoVisible = false"></button>
    </ng-template>
</p-dialog>

<m-historical-dialog [(visible)]="patientShowHistorical" [items]="patientHistoricalItems"></m-historical-dialog>
